/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getInstitution } from "network/ApiAxios";
import './UserData.css'
// reactstrap components
import {
    Spinner,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Button
} from "reactstrap";
import secureLocalStorage from "react-secure-storage";

const UserData = (props) => {
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const navigate = useNavigate();
    const [institution, setInstitution] = useState({});
    const [isLoading, setisLoading] = useState(true);

    useEffect(() => {
        const runAsync = async (institutionId) => {
            const response = await getInstitution(institutionId);
            const { data } = response;

            if (data.success) {
                setInstitution(data.institution);
                setisLoading(false)
            }
        }

        if (user?.credential?.institution) {
            runAsync(user.credential.institution)
        }
    }, [isLoading])

    return (
        <Col className="order-xl-2" xl="8">
            <Card className="bg-white rounded-lg shadow-sm" style={{ borderRadius: '0.5rem', overflow: 'hidden' }}>
                <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                        <Col xs="8">
                            <h3 className="mb-0">My account</h3>
                        </Col>
                         <Col className="text-right" xs="4">
                            <Button
                                color="primary"
                                onClick={() => navigate('/admin/edit-profile')}
                                size="sm"
                            >
                                Edit
                            </Button>
                        </Col> 
                    </Row>
                </CardHeader>
                <CardBody className="bg-white">
                    <Form>
                        <h6 className="heading-small text-muted mb-4">
                            User information (from database)
                        </h6>
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-username"
                                        >
                                            Username
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            defaultValue={user.name}
                                            id="input-username"
                                            placeholder="Username"
                                            type="text"
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-email"
                                        >
                                            Email address
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            id="input-email"
                                            defaultValue={user.email}
                                            type="email"
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                        <hr className="my-4" />
                        {user?.credential?.institution ?
                            <div>

                                <h6 className="heading-small text-muted mb-4">
                                    Institution Information
                                </h6>
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-institution-name"
                                                >
                                                    Name
                                                </label>
                                                {isLoading ?
                                                    <div className="text-center p-5">
                                                        <Spinner size="lg" />
                                                    </div>
                                                    :
                                                    <Input
                                                        className="form-control-alternative"
                                                        defaultValue={institution?.name}
                                                        id="input-institution-name"
                                                        placeholder="Institution Name"
                                                        type="text"
                                                        disabled
                                                    />
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-institution-email"
                                                >
                                                    Email address
                                                </label>
                                                {isLoading ?
                                                    <div className="text-center p-5">
                                                        <Spinner size="lg" />
                                                    </div>
                                                    :
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-institution-email"
                                                        defaultValue={institution?.email}
                                                        type="email"
                                                        disabled
                                                    />
                                                }
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            :
                            <div>

                            </div>
                        }

                        {/* <div className="pl-lg-4">
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-address"
                                        >
                                            Address
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            defaultValue="Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09"
                                            id="input-address"
                                            placeholder="Home Address"
                                            type="text"
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            
                        </div> */}

                    </Form>
                </CardBody>
            </Card>
        </Col>
    )

}

export default UserData;